import Breadcrumbs from "../react_components/breadcrumbs";
import ResponsivePageAdContainer from "../react_components/ads/responsive_page_ad_container";
import SimilarAuthorsList from "../react_components/author/similar_authors_list";
import SimilarBooksList from "../react_components/books_similar/similar_books_list";

import AuthorFollowStore from "../react_stores/author_follow_store";

export const SimilarBooksAuthorsComponents = {
  Breadcrumbs,
  ResponsivePageAdContainer,
  SimilarAuthorsList,
  SimilarBooksList,
};

export const SimilarBooksAuthorsStores = {
  AuthorFollowStore,
};
